import {inject, bindable} from 'aurelia-framework';  
import {InquiryAPI} from '../../services/inquiryAPI';
import {UserMessageService} from '../../services/userMessageService';

@inject(InquiryAPI, UserMessageService)
export class Inquiry {
   
    constructor(api, userMessageService) {

        this.api = api;
        this.userMessageService = userMessageService;
        
    }

    submit() {
        
        if(this.validate()) {
            this.api.submit(this.getData(), this.signupSuccess.bind(this), this.signupError.bind(this));
        }
    }

    signupSuccess(user) {
        this.userMessageService.setUserMessage("inquiry", "Contact information submitted!  Thank you for your interest!");
        this.clearForm();
        setTimeout(this.close.bind(this), 2500); 
    }

    signupError(msg) {
        this.userMessageService.setUserError("inquiry", msg);
        
    }



    getData() {
        var data = { 
            "email": this.email,
            "first_name": this.firstName,
            "last_name": this.lastName,
            "org_name": this.orgName,
            "phone": this.phone,
            "website": this.website,
            "comments": this.comments
        }

        return data;
    }

    clearForm() {
        this.email = null;
        this.firstName = null;
        this.lastName = null;
        this.orgName = null;
        this.phone = null;
        this.website = null;
        this.comments = null;
       
    }
    validate() {
        var pass = true;
        
        if(this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("inquiry", "Email is empty");
            pass = false;
        }
        if(!this.is_email(this.email)) {
            this.userMessageService.setUserError("inquiry", "Email is not a valid email address");
            pass = false;
        }

        if(this.firstName == null || this.firstName.trim() == '') {
            this.userMessageService.setUserError("inquiry", "First name is empty");
            pass = false;
        }

        if(this.lastName == null || this.lastName.trim() == '') {
            this.userMessageService.setUserError("inquiry", "Last name is empty");
            pass = false;
        }
       
        return pass;
            
    }

    is_email(email)
    {      
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailReg.test(email); 
    } 
    
}
